export const SUPPORTED_LANGUAGES = [
  {
    code: 'en',
    name: 'English',
    localName: 'English',
    shortName: 'EN',
    flag: '🇺🇸',
    countryCode: 'US',
  },
  {
    code: 'es',
    name: 'Spanish',
    localName: 'Español',
    shortName: 'ES',
    flag: '🇪🇸',
    countryCode: 'ES',
  },
  {
    
    code: 'fr',
    name: 'French',
    localName: 'Français',
    shortName: 'FR',
    flag: '🇫🇷',
    countryCode: 'FR',
  },
  {
    code: 'de',
    name: 'German',
    localName: 'Deutsch',
    shortName: 'DE',
    flag: '🇩🇪',
    countryCode: 'DE',
  },
  {
    code: 'fil',
    name: 'Filipino',
    localName: 'Filipino',
    shortName: 'PH',
    flag: '🇵🇭',
    countryCode: 'PH',
  },
  {
    code: 'ja',
    name: 'Japanese',
    localName: '日本語',
    shortName: 'JA',
    flag: '🇯🇵',
    countryCode: 'JP',
  },
  {
    code: 'pt',
    name: 'Portuguese',
    localName: 'Português',
    shortName: 'PT',
    flag: '🇵🇹',
    countryCode: 'PT',
  },
  {
    code: 'it',
    name: 'Italian',
    localName: 'Italiano',
    shortName: 'IT',
    flag: '🇮🇹',
    countryCode: 'IT',
  },
  {
    code: 'pl',
    name: 'Polish',
    localName: 'Polski',
    shortName: 'PL',
    flag: '🇵🇱',
    countryCode: 'PL',
  },
  {
    code: 'zh',
    name: 'Chinese',
    localName: '中文',
    shortName: 'ZH',
    flag: '🇨🇳',
    countryCode: 'CN',
  },
];

export const DEFAULT_LANGUAGE = 'en';
